<template>
  <v-col sm="12" md="12" lg="12">
    <v-snackbar
      :value="snackbar"
      :color="component.httpStatus == 200 ? 'green' : 'red'"
      :timeout="component.httpStatus == 200 ? 2000 : 0"
      :vertical="false"
    >
      {{ component.message }}
      <v-btn dark @click="hide = true">
        Close
      </v-btn>
    </v-snackbar>
  </v-col>
</template>
<script>
export default {
  name: "AppAlert",
  props: ["component"],
  data() {
    return {
      hide: false
    };
  },

  computed: {
    snackbar: function() {
      if (this.hide) return false;
      if (this.component.httpStatus !== 0) return true;
      return false;
    },
    submitted: function() {
      if (this.component.httpStatus === 200) {
        return "success";
      } else return "error";
    }
  }
};
</script>
